import styled from 'styled-components'
import { desktop } from '../../styles/media'
import { StyledIcon } from '../general/Icon'

const DarkButton = styled.button`
	background: #444;
	border: 0;
	border-radius: 2px;
	color: #EEE;
	cursor: pointer;
	font-size: 0.9rem;
	height: 40px;
	padding: 0 0.75rem;

	align-items: center;
	display: flex;

	${props => props.active && `
		background: #666;
		color: #FFF;
	`}

	${props => props.activePrimary && `
		color: #FFF;
		box-shadow: 0 0 0 2px ${props.theme.primary};
		position: relative;

		${props.activeFilters && `
			&:after {
				content: "${props.activeFilters}";
				display: block;
				position: absolute;
				top: 2px;
				right: 2px;

				font-size: 0.7rem;
				font-weight: bold;
				text-align: right;
				margin-left: auto;

				background: ${props.theme.primary};
				border-radius: 50%;
				color: #FFF;
				height: 18px;
				min-width: 18px;

				align-items: center;
				display: flex;
				justify-content: center;
			}
		`}
	`}

	${props => props.disabled && `
		opacity: 0.5;
		pointer-events: none;
	`}

	${desktop`
		${props => !props.activePrimary && `
			&:hover {
				background: #666;
				color: #FFF
			}
		`}
	`}

	${props => !props.activePrimary && `
		&:active {
			background: #666;
			color: #FFF;
		}
	`}

	${StyledIcon} {
		& + * {
			margin-left: 0.5rem;
		}
	}
`

export default DarkButton
